import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';
import "./../custom.css"

export class Layout extends Component {
  static displayName = Layout.name;

  render() {
    return (
      <div>
        <NavMenu style={{maxWidth: "85%"}}/>
        <Container>
          {this.props.children}
        </Container>
      </div>
    );
  }
}
